import { useGetChainDispensariesLazyQuery } from 'types/graphql';
import { DispensaryChainReturn } from './types';

export function useDispensaryChainsLazy(): DispensaryChainReturn {
  const [getDispensaryChain, { data, ...apolloValues }] = useGetChainDispensariesLazyQuery();

  return { dispensaryChainLocations: data?.filteredDispensaries, getDispensaryChain, ...apolloValues };
}
